"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEFAULT_IS_AUTHENTICATED_REDUCER_PROPERTY_PATH = exports.DEFAULT_AUTHENTICATED_PATH = exports.DEFAULT_LOGIN_PATH = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.ensureAuthenticatedOnEnter = ensureAuthenticatedOnEnter;
exports.toAuthenticatedOnEnter = toAuthenticatedOnEnter;
exports.ensureAuthenticatedOnUpdate = ensureAuthenticatedOnUpdate;
exports.toAuthenticatedOnUpdate = toAuthenticatedOnUpdate;

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _selectn = require("selectn");

var _selectn2 = _interopRequireDefault(_selectn);

var _reactRedux = require("react-redux");

var _connectRouter = require("./connectRouter");

var _connectRouter2 = _interopRequireDefault(_connectRouter);

var _hoistNonReactStatics = require("hoist-non-react-statics");

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __assign = undefined && undefined.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};

// default constants (these can be overwritten through the public hook or HOC function exports signatures)
// /login is by default expected to be the route path were authentication takes place
var DEFAULT_LOGIN_PATH = exports.DEFAULT_LOGIN_PATH = "/login";
// / is by default expected to be the route path were authenticated users will be transitioned to
var DEFAULT_AUTHENTICATED_PATH = exports.DEFAULT_AUTHENTICATED_PATH = "/";
// reducer default path to the redux reducer flag indicating if we are authenticated currently
var DEFAULT_IS_AUTHENTICATED_REDUCER_PROPERTY_PATH = exports.DEFAULT_IS_AUTHENTICATED_REDUCER_PROPERTY_PATH = "auth.isAuthenticated";
// running! - only redirect on the first time after rehydration! -- see IB-181 #1 -- https://jira.allaboutapps.at/browse/IB-181
var REHYDRATION_REDIRECT_WAS_EXECUTED_ONCE = false;
// private function that does the router replacing operations for us when we are not authenticated.
function _ensureAuthenticatedTransition(replace, isAuthenticated, loginPath, pathname, isRehydrationComplete) {
    if (isAuthenticated === false) {
        if (__DEVELOPMENT__) {
            console.log("_ensureAuthenticatedTransition executes. isAuthenticated=" + isAuthenticated + " loginPath=" + loginPath + " pathname=" + pathname + " isRehydrationComplete=" + isRehydrationComplete);
        }
        // user is not allowed to access this route while unauthenticated, replace the route now
        // no longer authenticated, transition to the login page!
        // redirect to login and add next param so we can redirect again after login
        // notice that we do this through the router itself, not through the dispatch (faster, plus we don't need to wait for rehydration to take place)
        if (isRehydrationComplete) {
            replace(loginPath + "?next=/");
        } else {
            replace(loginPath + "?next=" + pathname);
        }
    }
}
// private function that does the router replacing operations for us when we are getting authenticated.
function _toAuthenticatedTransition(replace, isAuthenticated, authenticatedPath, nextPath, isRehydrationComplete) {
    if (isAuthenticated === true) {
        if (__DEVELOPMENT__) {
            console.log("_toAuthenticatedTransition executes. isAuthenticated=" + isAuthenticated + " nextPath=" + nextPath + " authenticatedPath=" + authenticatedPath + " isRehydrationComplete=" + isRehydrationComplete);
        }
        // we are now authenticated, transition to the default authenticatedPath or nextPath (if set)
        // notice that we use the router here directly and not through dispatch (no need to wait for rehydration)
        // disable autenticated path redirection after rehydration was completed, see IB-181 #1 -- https://jira.allaboutapps.at/browse/IB-181
        if (nextPath && REHYDRATION_REDIRECT_WAS_EXECUTED_ONCE === false) {
            if (isRehydrationComplete) {
                if (__DEVELOPMENT__) {
                    console.log("_toAuthenticatedTransition: last time nextPath redirect after rehydration!");
                }
                REHYDRATION_REDIRECT_WAS_EXECUTED_ONCE = true;
            }
            return replace(nextPath);
        }
        return replace(authenticatedPath);
    }
    return true;
}
// public react-router route onEnter shortcut hook to check authentication reducer (without rendering the route)
function ensureAuthenticatedOnEnter(store) {
    var loginPath = arguments.length <= 1 || arguments[1] === undefined ? DEFAULT_LOGIN_PATH : arguments[1];
    var isAuthenticatedReducerPropertyPath = arguments.length <= 2 || arguments[2] === undefined ? DEFAULT_IS_AUTHENTICATED_REDUCER_PROPERTY_PATH : arguments[2];

    return function onEnterAuthenticatedRoute(routerNextState, replace) {
        _ensureAuthenticatedTransition(replace, (0, _selectn2.default)(isAuthenticatedReducerPropertyPath, store.getState()), loginPath, routerNextState.location.pathname, store.getState().app.isRehydrationComplete);
    };
}
// public react-router route onEnter shortcut hook to check authentication reducer (without rendering the route)
function toAuthenticatedOnEnter(store) {
    var authenticatedPath = arguments.length <= 1 || arguments[1] === undefined ? DEFAULT_AUTHENTICATED_PATH : arguments[1];
    var isAuthenticatedReducerPropertyPath = arguments.length <= 2 || arguments[2] === undefined ? DEFAULT_IS_AUTHENTICATED_REDUCER_PROPERTY_PATH : arguments[2];

    return function onEnterAuthenticatedRoute(routerNextState, replace) {
        _toAuthenticatedTransition(replace, (0, _selectn2.default)(isAuthenticatedReducerPropertyPath, store.getState()), authenticatedPath, routerNextState.location.query.next, store.getState().app.isRehydrationComplete);
    };
}
// public re-checks on any updates of a encapsulated route component (route already rendered)
function ensureAuthenticatedOnUpdate(RouteTargetComponent) {
    var loginPath = arguments.length <= 1 || arguments[1] === undefined ? DEFAULT_LOGIN_PATH : arguments[1];
    var isAuthenticatedReducerPropertyPath = arguments.length <= 2 || arguments[2] === undefined ? DEFAULT_IS_AUTHENTICATED_REDUCER_PROPERTY_PATH : arguments[2];

    var EnsureAuthenticatedHOC = function (_Component) {
        _inherits(EnsureAuthenticatedHOC, _Component);

        function EnsureAuthenticatedHOC() {
            _classCallCheck(this, EnsureAuthenticatedHOC);

            return _possibleConstructorReturn(this, Object.getPrototypeOf(EnsureAuthenticatedHOC).apply(this, arguments));
        }

        _createClass(EnsureAuthenticatedHOC, [{
            key: "componentDidMount",
            value: function componentDidMount() {
                var _props = this.props;
                var router = _props.router;
                var isAuthenticated = _props.isAuthenticated;
                var pathname = _props.pathname;
                var isRehydrationComplete = _props.isRehydrationComplete;
                // Component will mount for the first time... (safety check, should be handled automatically by ensureAuthenticatedOnEnter if setup correctly)

                _ensureAuthenticatedTransition(router.replace, isAuthenticated, loginPath, pathname, isRehydrationComplete);
            }
        }, {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                var router = nextProps.router;
                var isAuthenticated = nextProps.isAuthenticated;
                var pathname = nextProps.pathname;
                var isRehydrationComplete = nextProps.isRehydrationComplete;
                // Component has updated, recheck if we are still authenticated (transitions to logout if no longer logged in)...

                _ensureAuthenticatedTransition(router.replace, isAuthenticated, loginPath, pathname, isRehydrationComplete);
            }
        }, {
            key: "render",
            value: function render() {
                // render the component that requires auth (passed to this wrapper)
                return React.createElement(RouteTargetComponent, __assign({}, this.props));
            }
        }]);

        return EnsureAuthenticatedHOC;
    }(_react.Component);

    EnsureAuthenticatedHOC.propTypes = {
        router: _react.PropTypes.object.isRequired,
        dispatch: _react.PropTypes.func.isRequired,
        isAuthenticated: _react.PropTypes.bool.isRequired,
        isRehydrationComplete: _react.PropTypes.bool.isRequired,
        pathname: _react.PropTypes.string.isRequired
    };
    function mapStateToProps(state, ownProps) {
        return {
            isAuthenticated: (0, _selectn2.default)(isAuthenticatedReducerPropertyPath, state),
            pathname: ownProps.location.pathname,
            isRehydrationComplete: state.app.isRehydrationComplete
        };
    }
    var GenericEnsureAuthenticatedHOC = EnsureAuthenticatedHOC;
    var connected = (0, _reactRedux.connect)(mapStateToProps)(GenericEnsureAuthenticatedHOC);
    // apply hoistStatics via hoist-non-react-statics here (copies static props, e.g. contextTypes)
    return (0, _hoistNonReactStatics2.default)((0, _connectRouter2.default)(connected), RouteTargetComponent);
}
// re-checks on any updates of a encapsulated route component (route already rendered)
function toAuthenticatedOnUpdate(RouteTargetComponent) {
    var authenticatedPath = arguments.length <= 1 || arguments[1] === undefined ? DEFAULT_AUTHENTICATED_PATH : arguments[1];
    var isAuthenticatedReducerPropertyPath = arguments.length <= 2 || arguments[2] === undefined ? DEFAULT_IS_AUTHENTICATED_REDUCER_PROPERTY_PATH : arguments[2];

    // eslint disable only for this line to allow another component to be defined in the same file.

    var TransitionsOnAuthenticatedHOC = function (_Component2) {
        _inherits(TransitionsOnAuthenticatedHOC, _Component2);

        function TransitionsOnAuthenticatedHOC() {
            _classCallCheck(this, TransitionsOnAuthenticatedHOC);

            return _possibleConstructorReturn(this, Object.getPrototypeOf(TransitionsOnAuthenticatedHOC).apply(this, arguments));
        }

        _createClass(TransitionsOnAuthenticatedHOC, [{
            key: "componentDidMount",
            value: function componentDidMount() {
                var _props2 = this.props;
                var router = _props2.router;
                var isAuthenticated = _props2.isAuthenticated;
                var query = _props2.query;
                var isRehydrationComplete = _props2.isRehydrationComplete;
                // handle cases were we are already authenticated when mount occured, no need to show this page.

                _toAuthenticatedTransition(router.replace, isAuthenticated, authenticatedPath, query.next, isRehydrationComplete);
            }
        }, {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                var router = nextProps.router;
                var isAuthenticated = nextProps.isAuthenticated;
                var query = nextProps.query;
                var isRehydrationComplete = nextProps.isRehydrationComplete;
                // handle cases were we get authenticated after logging in successfully

                _toAuthenticatedTransition(router.replace, isAuthenticated, authenticatedPath, query.next, isRehydrationComplete);
            }
        }, {
            key: "render",
            value: function render() {
                // render the component that requires auth (passed to this wrapper)
                return React.createElement(RouteTargetComponent, __assign({}, this.props));
            }
        }]);

        return TransitionsOnAuthenticatedHOC;
    }(_react.Component);

    TransitionsOnAuthenticatedHOC.propTypes = {
        router: _react.PropTypes.object.isRequired,
        dispatch: _react.PropTypes.func.isRequired,
        isAuthenticated: _react.PropTypes.bool.isRequired,
        query: _react.PropTypes.object.isRequired
    };
    function mapStateToProps(state, ownProps) {
        var query = Object.assign({}, ownProps.location.query); // query can also be undefined, catch this and always supply an object.
        return {
            isAuthenticated: (0, _selectn2.default)(isAuthenticatedReducerPropertyPath, state),
            query: query,
            isRehydrationComplete: state.app.isRehydrationComplete
        };
    }
    var GenericTransitionsOnAuthenticatedHOC = TransitionsOnAuthenticatedHOC;
    var connected = (0, _reactRedux.connect)(mapStateToProps)(GenericTransitionsOnAuthenticatedHOC);
    // apply hoistStatics via hoist-non-react-statics here (copies static props, e.g. contextTypes)
    return (0, _hoistNonReactStatics2.default)((0, _connectRouter2.default)(connected), RouteTargetComponent);
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/decorators/routeAuthentication.tsx
 ** module id = 1313
 ** module chunks = 0
 **/